import * as sortStates from '@/consts/sortStates'
export default {
  methods: {
    sortedArrayBy(arr, sortRules) {
      if (!(sortRules instanceof Array)) {
        sortRules = [sortRules]
      }
      arr = arr.slice()
      arr.sort((a, b) => {
        for (let i = 0, len = sortRules.length; i < len; i++) {
          const { prop, sortState } = sortRules[i]
          if (sortState === sortStates.SORT_STATE_NONE) {
            return 0
          }
          const desc = sortState === sortStates.SORT_STATE_DESC
          const v1 = a[prop]
          const v2 = b[prop]
          const ret1 = desc ? 1 : -1
          const ret2 = desc ? -1 : 1
          if (v1 < v2) { return ret1 }
          if (v1 > v2) { return ret2 }
        }
        return 0
      })
      return arr
    },
  }
}
